import {
  type DeliveryEntryData,
  type ShipmentLineData,
  type ShipmentInformationDataWrapper,
} from "~/domains/orders/types/models";
import { type OrderLineItemData } from "~/domains/orders/types/modelsV2";

export const buildShipmentInformationDataWrapper = (
  deliveryEntries: DeliveryEntryData[],
  products: OrderLineItemData[],
): ShipmentInformationDataWrapper => {
  const orderDetailsData: Dict<OrderLineItemData[]> = {};

  if (!deliveryEntries?.length) {
    return { orderDetailsData };
  }

  deliveryEntries.forEach((deliveryEntry) => {
    Object.values(deliveryEntry.packages ?? {}).forEach((shipmentPackages: ShipmentLineData[]) => {
      shipmentPackages.forEach((shipmentPackage) => {
        const packageId =
          shipmentPackage.externalHandlingUnitId !== ""
            ? shipmentPackage.externalHandlingUnitId
            : deliveryEntry.deliveryNumber;

        if (!orderDetailsData[packageId]) {
          orderDetailsData[packageId] = [];
        }

        const orderEntries = products.filter((entry) =>
          entry.lineNo.includes(":")
            ? entry.lineNo === `${shipmentPackage.lineNumber}:${shipmentPackage.scheduleLineNumber}`
            : entry.lineNo === `${shipmentPackage.lineNumber}`,
        );

        orderEntries.forEach((orderEntry) => {
          const alreadyAdded = orderDetailsData[packageId].some((entry) => entry.lineNo === orderEntry.lineNo);
          if (!alreadyAdded) {
            orderDetailsData[packageId].push(orderEntry);
          }
        });
      });
    });
  });

  return { orderDetailsData };
};
